import {
  Component,
  effect,
  ElementRef,
  EventEmitter,
  inject,
  input,
  model,
  OnChanges,
  output,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { NgIcon } from '@ng-icons/core';
import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';
import { DictionaryService } from '../../services/dictionary.service';
import { SnackbarService } from '../../services/snackbar.service';
declare var $: any;

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  imports: [CommonModule, NgIcon, LoadingSpinnerComponent],
})
export class ModalComponent implements OnChanges {
  protected dictionaryService = inject(DictionaryService);
  private snackbarService = inject(SnackbarService);

  title = input<string>('');
  opened = model<boolean>(false);
  size = input<'sm' | 'md' | 'lg' | 'xl' | 'xxl'>('md'); // TODO: replace with Size type after merge
  noGap = input<boolean>(false);
  loading = input<boolean>(false);
  loadError = input<boolean>(false);
  loadErrorMessage = input<string>('');

  closeTrigger = output<boolean>();

  constructor() {
    effect(() => {
      if (this.opened() && this.loadError()) {
        const msg = this.loadErrorMessage() || this.dictionaryService.get('FailedToLoadData');
        this.snackbarService.showError(msg);
        this.close();
      }
    }, { allowSignalWrites: true });
  }

  visible = false;
  timer: any | undefined;

  @ViewChild('content', { static: true }) public content:
    | ElementRef<HTMLDivElement>
    | undefined;

  close() {
    this.visible = false;
    clearTimeout(this.timer);
    this.opened.set(false);

    if (this.content) {
      this.content.nativeElement.scrollTop = 0;
    }

    this.closeTrigger.emit(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.opened()) {
      clearTimeout(this.timer);
      setTimeout(() => {
        this.visible = true;
      }, 10);
    } else {
      this.visible = false;
      clearTimeout(this.timer);
    }
  }
}
